export default __webpack_public_path__ + "static/media/Inter.var.c2fe3cb2.woff2";